module.exports = __webpack_public_path__ + "img/1-5.9fe4bee0.png";